import { getType, types } from "mobx-state-tree";
import Audit from "../../../models/Audit";
import AuditStore from "../../../stores/domain/AuditStore";


export const AuditSelectState = types.model('AuditSelectState',{
  selectStateUuid: types.identifier,
  auditStore: types.maybe(types.late(() => types.reference(AuditStore))),
  selected: types.maybe(types.safeReference(Audit)),
  readonly: types.optional(types.boolean, false),
}).volatile(self => ({
  notifySelect: types.function,
  // selectedSchema: types.object
})).actions((self)=>({
  setConsumer(f){
    self.notifySelect = f
  },
  select(audit) {
    self.notifySelect(audit)
    self.selected = audit;
  },
  setDefaultSelect() {
    self.selected = undefined
  },

  // initDefaults(){
  //   //the url is the default type for every tenant.
  //   self.store.codeTypes.forEach((codeType) => {
  //     if (codeType.name ==='url') {
  //       self.select(codeType);
  //     }
  //   })
  // },
  afterCreate() {
    console.log("Instantiated " + getType(self).name)
    self.notifySelect = (data) => { //TODO
      console.log("placeholder notifySelect")
    }

    self.selectedSchema = {}

  }

})).views( (self) => ({
  options() {
    const { auditOptions } = self.auditStore || [];
    return auditOptions;
  },
}))
